import * as i2 from '@acorex/components/common';
import { MXInputBaseValueComponent, MXLookComponent, AXSearchableComponent, AXComponent, AXFocusableComponent, AXClearableComponent, AXValuableComponent, AXNgModelDelayedValueChangedDirective } from '@acorex/components/common';
import * as i0 from '@angular/core';
import { forwardRef, Component, ChangeDetectionStrategy, ViewEncapsulation, Optional, Inject, Input, HostBinding, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { classes } from 'polytype';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@acorex/core/translation';
import { AXTranslationModule } from '@acorex/core/translation';
import { AXButtonModule } from '@acorex/components/button';
import { AXDecoratorModule } from '@acorex/components/decorators';
import { AXTextBoxModule } from '@acorex/components/text-box';

class AXSearchBoxComponent extends classes((MXInputBaseValueComponent), MXLookComponent) {
    constructor(_parent) {
        super();
        this._parent = _parent;
        this.delayTime = 500;
    }
    _handleModelChange(value) {
        if (this._parent && this._parent.search) {
            this._parent.search(value);
        }
        this.commitValue(value, true);
    }
    get __hostClass() {
        return ['ax-editor-container', `ax-look-${this.look}`, `${this.disabled ? 'ax-state-disabled' : ''}`];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXSearchBoxComponent, deps: [{ token: AXSearchableComponent, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.0.2", type: AXSearchBoxComponent, selector: "ax-search-box", inputs: { disabled: "disabled", readonly: "readonly", tabIndex: "tabIndex", placeholder: "placeholder", value: "value", state: "state", name: "name", id: "id", look: "look", delayTime: "delayTime" }, outputs: { valueChange: "valueChange", stateChange: "stateChange", onValueChanged: "onValueChanged", onBlur: "onBlur", onFocus: "onFocus", readonlyChange: "readonlyChange", disabledChange: "disabledChange", onKeyDown: "onKeyDown", onKeyUp: "onKeyUp", onKeyPress: "onKeyPress" }, host: { properties: { "class": "this.__hostClass" } }, providers: [
            { provide: AXComponent, useExisting: AXSearchBoxComponent },
            { provide: AXFocusableComponent, useExisting: AXSearchBoxComponent },
            { provide: AXClearableComponent, useExisting: AXSearchBoxComponent },
            { provide: AXValuableComponent, useExisting: AXSearchBoxComponent },
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => AXSearchBoxComponent),
                multi: true,
            },
        ], usesInheritance: true, ngImport: i0, template: "<ng-content select=\"ax-prefix\"> </ng-content>\n\n<div #icon>\n  <ng-content select=\"ax-icon\"> </ng-content>\n</div>\n\n@if (!icon.children.length) {\n  <span class=\"ax-icon ax-icon-search ax-editor-control\"></span>\n}\n\n<input\n  #input\n  class=\"ax-input\"\n  [attr.name]=\"name\"\n  [attr.placeholder]=\"placeholder ?? 'search' | translate | async\"\n  [class.ax-state-disabled]=\"disabled\"\n  [class.ax-state-readonly]=\"readonly\"\n  [disabled]=\"disabled\"\n  [readonly]=\"readonly\"\n  [tabindex]=\"tabIndex\"\n  [ngModel]=\"value\"\n  [delayTime]=\"delayTime\"\n  (axDelayedValueChanged)=\"_handleModelChange($event)\"\n  (keydown)=\"emitOnKeydownEvent($event)\"\n  (keyup)=\"emitOnKeyupEvent($event)\"\n  (keypress)=\"emitOnKeypressEvent($event)\"\n  (focus)=\"emitOnFocusEvent($event)\"\n  (blur)=\"emitOnBlurEvent($event)\"\n/>\n\n@if (input.value && !disabled && !readonly) {\n  <ng-content select=\"ax-clear-button\"></ng-content>\n}\n<ng-content select=\"ax-suffix\"> </ng-content>\n", dependencies: [{ kind: "directive", type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i2.AXNgModelDelayedValueChangedDirective, selector: "[axDelayedValueChanged]", inputs: ["delayTime"], outputs: ["axDelayedValueChanged", "axDelayTimeChange"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: i4.AXTranslatorPipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXSearchBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ax-search-box', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, inputs: ['disabled', 'readonly', 'tabIndex', 'placeholder', 'value', 'state', 'name', 'id', 'look'], outputs: [
                        'valueChange',
                        'stateChange',
                        'onValueChanged',
                        'onBlur',
                        'onFocus',
                        'readonlyChange',
                        'disabledChange',
                        'onKeyDown',
                        'onKeyUp',
                        'onKeyPress',
                    ], providers: [
                        { provide: AXComponent, useExisting: AXSearchBoxComponent },
                        { provide: AXFocusableComponent, useExisting: AXSearchBoxComponent },
                        { provide: AXClearableComponent, useExisting: AXSearchBoxComponent },
                        { provide: AXValuableComponent, useExisting: AXSearchBoxComponent },
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => AXSearchBoxComponent),
                            multi: true,
                        },
                    ], template: "<ng-content select=\"ax-prefix\"> </ng-content>\n\n<div #icon>\n  <ng-content select=\"ax-icon\"> </ng-content>\n</div>\n\n@if (!icon.children.length) {\n  <span class=\"ax-icon ax-icon-search ax-editor-control\"></span>\n}\n\n<input\n  #input\n  class=\"ax-input\"\n  [attr.name]=\"name\"\n  [attr.placeholder]=\"placeholder ?? 'search' | translate | async\"\n  [class.ax-state-disabled]=\"disabled\"\n  [class.ax-state-readonly]=\"readonly\"\n  [disabled]=\"disabled\"\n  [readonly]=\"readonly\"\n  [tabindex]=\"tabIndex\"\n  [ngModel]=\"value\"\n  [delayTime]=\"delayTime\"\n  (axDelayedValueChanged)=\"_handleModelChange($event)\"\n  (keydown)=\"emitOnKeydownEvent($event)\"\n  (keyup)=\"emitOnKeyupEvent($event)\"\n  (keypress)=\"emitOnKeypressEvent($event)\"\n  (focus)=\"emitOnFocusEvent($event)\"\n  (blur)=\"emitOnBlurEvent($event)\"\n/>\n\n@if (input.value && !disabled && !readonly) {\n  <ng-content select=\"ax-clear-button\"></ng-content>\n}\n<ng-content select=\"ax-suffix\"> </ng-content>\n" }]
        }], ctorParameters: () => [{ type: i2.AXSearchableComponent, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [AXSearchableComponent]
                }] }], propDecorators: { delayTime: [{
                type: Input
            }], __hostClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

const COMPONENT = [AXSearchBoxComponent];
const MODULES = [
    CommonModule,
    FormsModule,
    AXTranslationModule,
    AXDecoratorModule,
    AXTextBoxModule,
    AXButtonModule,
    AXNgModelDelayedValueChangedDirective,
];
class AXSearchBoxModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXSearchBoxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.0.2", ngImport: i0, type: AXSearchBoxModule, declarations: [AXSearchBoxComponent], imports: [CommonModule,
            FormsModule,
            AXTranslationModule,
            AXDecoratorModule,
            AXTextBoxModule,
            AXButtonModule,
            AXNgModelDelayedValueChangedDirective], exports: [AXSearchBoxComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXSearchBoxModule, imports: [CommonModule,
            FormsModule,
            AXTranslationModule,
            AXDecoratorModule,
            AXTextBoxModule,
            AXButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXSearchBoxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...COMPONENT],
                    imports: [...MODULES],
                    exports: [...COMPONENT],
                    providers: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AXSearchBoxComponent, AXSearchBoxModule };
